import { render, staticRenderFns } from "./staffing.vue?vue&type=template&id=2bb2465a&scoped=true&"
import script from "./staffing.vue?vue&type=script&lang=js&"
export * from "./staffing.vue?vue&type=script&lang=js&"
import style0 from "./staffing.vue?vue&type=style&index=0&id=2bb2465a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb2465a",
  null
  
)

export default component.exports